// extracted by css-extract-rspack-plugin
export default {"middlePaneGrid":"IssueIndexPage-module__middlePaneGrid__Opwdk","feedbackLinkContainer":"IssueIndexPage-module__feedbackLinkContainer__VOiTi"};